const appEnv = process.env.VUE_APP_ENV || process.env.NODE_ENV || 'development';

const API_BY_ENV = {
  production: 'https://api.nasehnutie.sk/',
  test: 'https://testapi.nasehnutie.sk/',
  development: 'http://localhost:8000/',
};

const apiBaseUrl = process.env.VUE_APP_API_BASE_URL || API_BY_ENV[appEnv] || API_BY_ENV.development;

export const APP_ENV = appEnv;
export const API_BASE_URL = apiBaseUrl;
export const TOKEN_STORAGE_KEY = `TOKEN_STORAGE_KEY_${appEnv}`;
export const USERNAME_STORAGE_KEY = `USERNAME_STORAGE_KEY_${appEnv}`;

